module.exports = __webpack_public_path__ + "img/company_03.7b4929fe.png";